export const ShouldShowBundleOnPackingSlipName = 'ShouldShowBundleOnPackingSlip';
export const EnableProductPriceName = 'enableProductPrice';
export const ProductPriceName = 'productPrice';
export const ProductPriceCurrencyCodeName = 'productPriceCurrencyCode';
export const ProductPackagePreference = 'productPackagePreference';
export const ProductPackagingRequirements = 'productPackagingRequirements';
export const ProductDangerousGoodsName = 'productDangerousGoods';
export const ShipStationFulfillmentBarcode = 'shipStationFulfillmentBarcode';
export const MaterialSafetyDataSheet = 'materialSafetyDataSheet';
export const ProductItemWeightName = 'productItemWeight';
export const ProductItemDimensionsName = 'productItemDimensions';
export const RequireSerialNumberName = 'requireSerialNumber';
